import queryString from 'query-string';

export const get = (key: string, search?: string): string => {
  let value = '';
  if (global.window) {
    const params = queryString.parse(search || window.location.search);
    const param = params[key];
    value =
      typeof param === 'string' ? param : JSON.stringify(params[key] || '');
  }

  return value;
};

export const getParsed = (key: string): any => {
  return JSON.parse(get(key));
};

export const parse = (
  query: string = window.location.search
): queryString.ParsedQuery<string> => queryString.parse(query);

export const toString = (obj: Record<string, unknown>): string => {
  return queryString.stringify(obj);
};

export const toUrl = (url: string, query: Record<string, any>): string => {
  return queryString.stringifyUrl({
    url,
    query,
  });
};
